module.exports = __webpack_public_path__ + "media/images/logo-7f2521c61664e891dacff48c116f4272.jpg";